<form #thisForm="ngForm">
  <app-dados-boleta
    titulo="Dados da Boleta - Operações Estruturadas"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <mat-expansion-panel [expanded]="">
    <mat-expansion-panel-header> Dados da Boleta </mat-expansion-panel-header>

    <div class="content">
      <app-dados-fundo
        #portfolio
        [canEdit]="canEdit()"
        [canValidate]="canValidate"
        [ticketType]="TicketTypeEnum.StructuredOperations"
      >
      </app-dados-fundo>

      <br />

      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Boleta</div>
        <br />

        <div class="card-body">
          <div class="row mb-2">
            <div class="col-4">
              <label class="form-label">Tipo de Operação</label>
              <select
                required
                class="form-control"
                id="operationType"
                [(ngModel)]="selectedTypeId"
                name="operationType"
                (change)="getOperationSubType(selectedTypeId)"
                [disabled]="!canEdit()"
              >
                <option value="0"></option>
                <option
                  *ngFor="let operationType of operationTypeList"
                  [value]="operationType.id"
                >
                  {{ operationType.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4">
              <label class="form-label">Subtipo da Operação</label>
              <select
                required
                class="form-control"
                id="operationSubType"
                [(ngModel)]="selectedSubTypeId"
                name="operationSubType"
                (change)="getOperationSubTypeFiles(selectedSubTypeId)"
                [disabled]="!canEdit()"
              >
                <option value="0"></option>
                <option
                  *ngFor="let operationSubType of operationSubTypeList"
                  [value]="operationSubType.id"
                >
                  {{ operationSubType.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-2">
            <div
              class="col-4"
              [class.has-error]="hasError('operationAbstract')"
            >
              <label>Resumo da Operação</label>
              <textarea
                class="form-control"
                data-cy="operationAbstract"
                rows="5"
                maxlength="1000"
                name="operationAbstract"
                [(ngModel)]="model.operationAbstract"
                [disabled]="!canEdit()"
                required
              >
              </textarea>
              <span class="text-right" *ngIf="model.operationAbstract != null"
                >{{ model.operationAbstract.length }}/1000 caracteres</span
              ><br />
            </div>
          </div>

          <div class="row mb-2" *ngIf="model.statusDescription != null">
            <div class="col-4">
              <input
                type="button"
                class="button"
                (click)="showModalComment()"
                value="Comentários"
              />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-4">
              <label>Anexos</label>
            </div>
            <form
              #thisForm="ngForm"
              *ngIf="canViewAttachments()"
              (ngSubmit)="submit()"
            >
              <div
                class="card mt-3"
                *ngFor="let item of operationSubTypeFileList"
              >
                <div class="card-body">
                  <div class="form-row">
                    <div class="row mb-2 col-12">
                      <label *ngIf="item.isMandatory"><strong>(Obrigatório)</strong> {{ item.name }}</label>
                      <label *ngIf="!item.isMandatory"><strong>(Não Obrigatório)</strong> {{ item.name }}</label>
                      <br />
                      <input
                        *ngIf="model.statusDescription == null"
                        required
                        #thisInput
                        type="file"
                        [name]="'file-' + item.id"
                        data-cy="uploadFile"
                        (change)="openFile($event, item.id)"
                      />
                    </div>
                  </div>
                  <div class="actions">
                    <input
                      *ngIf="model.statusDescription == null"
                      type="button"
                      value="Upload"
                      data-cy="submit"
                      class="btn btn-primary"
                      (tempTicketId)="setTempId($event)"
                      appDebounceClick
                      (debounceClick)="submit(item)"
                      [debounceTime]="200"
                    />
                  </div>
                  <app-file-list-table
                    #fileListTable
                    [ticketId]="model.id"
                    [tempId]="tempId"
                    [canEdit]="canEdit()"
                    [structuredSubTypeFile]="item.id"
                    (emitterAllFileList)="getAllFileList($event)"
                  >
                  </app-file-list-table>
                </div>
              </div>
            </form>
          </div>
          <br />
        </div>
      </div>
      <br />

      <div class="card mt-3" *ngIf="isOtherAssets() || isCreditAsset()">
        <div class="card-header text-uppercase">Dados do Originador</div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col">
              <label
                for="
              originatorName"
                >Nome/Razão Social
              </label>
              <input
                type="text"
                class="form-control"
                data-cy="originatorName"
                name="originatorName"
                [(ngModel)]="model.originatorName"
                [required]="isOtherAssets() || isCreditAsset()"
              />
            </div>

            <div class="col" [class.has-error]="hasError('originatorDocument')">
              <label for="originatorDocument">CPF/CNPJ</label>
              <input
                type="text"
                class="form-control"
                data-cy="originatorDocument"
                name="originatorDocument"
                [(ngModel)]="model.originatorDocument"
                [required]="isOtherAssets() || isCreditAsset()"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="card mt-3"
        *ngIf="
          isPartnerParticipation() ||
          isOtherAssets() ||
          isRealEstateAsset() ||
          isDebenture()
        "
      >
        <div class="card-header text-uppercase">Dados do Ativo</div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col" *ngIf="isPartnerParticipation() || isDebenture()">
              <label
                for="
              activeName"
                >Nome/Razão Social
              </label>
              <input
                type="text"
                class="form-control"
                data-cy="activeName"
                name="activeName"
                [(ngModel)]="model.activeName"
                [required]="isPartnerParticipation() || isDebenture()"
              />
            </div>

            <div
              class="col"
              *ngIf="isPartnerParticipation() || isCreditAsset()"
            >
              <label for="activeDocument">CPF/CNPJ</label>
              <input
                type="number"
                class="form-control"
                data-cy="activeDocument"
                name="activeDocument"
                [(ngModel)]="model.activeDocument"
                [required]="isPartnerParticipation() || isCreditAsset()"
              />
            </div>

            <div class="col" *ngIf="isOtherAssets()">
              <label for="activeProcess">Número do processo</label>
              <input
                type="number"
                class="form-control"
                data-cy="activeProcess"
                name="activeProcess"
                maxlength="100"
                [(ngModel)]="model.activeProcess"
                [required]="isOtherAssets()"
              />
            </div>
          </div>
          <div class="row mb-2" *ngIf="isRealEstateAsset()">
            <div class="col">
              <label
                for="
              activeRegistration"
                >Número de Matrícula
              </label>
              <input
                type="number"
                class="form-control"
                data-cy="activeRegistration"
                name="activeRegistration"
                [(ngModel)]="model.activeRegistration"
                [required]="isRealEstateAsset()"
              />
            </div>

            <div class="col">
              <label for="activeCity">Cidade</label>
              <input
                type="text"
                class="form-control"
                data-cy="activeCity"
                name="activeCity"
                [(ngModel)]="model.activeCity"
                [required]="isRealEstateAsset()"
              />
            </div>

            <div class="col">
              <label for="activeUF">UF</label>
              <input
                type="text"
                class="form-control"
                data-cy="activeUF"
                name="activeUF"
                maxlength="2"
                [(ngModel)]="model.activeUF"
                (ngModelChange)="model.activeUF = $event.toUpperCase()"
                [required]="isRealEstateAsset()"
              />
            </div>
          </div>
        </div>
      </div>

      <app-annotation
        #annotation
        [annotation]="model.annotations"
      ></app-annotation>
    </div>
  </mat-expansion-panel>

  <div
    *ngIf="
      model.statusId == WorkFlowStatusEnum.StructuredReadyToOperate ||
      model.statusId == WorkFlowStatusEnum.StructuredFinalReviewerDecision ||
      model.statusId == WorkFlowStatusEnum.StructuredCompleted ||
      model.statusId == WorkFlowStatusEnum.StructuredInAnalysis ||
      model.statusId == WorkFlowStatusEnum.StructuredReservationAnalysis ||
      model.statusId ==
        WorkFlowStatusEnum.StructuredCancelledInReservationAnalysis ||
      model.statusId == WorkFlowStatusEnum.StructuredCancelledInAnalysis
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Pareceristas </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="content">
        <mat-table #table [dataSource]="reviewersDecisionModelList">
          <!-- Account No. Column -->
          <ng-container matColumnDef="groupName">
            <mat-header-cell *matHeaderCellDef> Nome do Grupo </mat-header-cell>
            <mat-cell *matCellDef="let element">{{
              element.groupName
            }}</mat-cell>
          </ng-container>

          <!-- Account Description Column -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <select
                [disabled]="
                  model.statusId != WorkFlowStatusEnum.StructuredInAnalysis
                "
                required
                class="form-control status-select"
                id="reviewersStatus"
                [(ngModel)]="element.reviewersDecisionStatus"
                name="reviewersStatus-{{ element.groupId }}"
                [ngClass]="getReviewClass(element.reviewersDecisionStatus)"
                (change)="
                  changeReviewerStatus(
                    element.reviewersDecisionStatus,
                    element.groupId
                  )
                "
              >
                <option
                  style="background-color: white"
                  *ngFor="let item of reviewersStatusList"
                  [value]="item.id"
                >
                  <b>{{ item.status }}</b>
                </option>
              </select>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="ColumnsReviewers"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ColumnsReviewers"> </mat-row>
        </mat-table>
      </div>
    </mat-expansion-panel>
  </div>

  <div *ngIf="canViewPrecedent()">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Precedente </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="content">
        <div class="table">
          <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z8 col-12"
          >
            <ng-container matColumnDef="modal">
              <th mat-header-cell *matHeaderCellDef>Detalhes</th>
              <td mat-cell *matCellDef="let element" class="actions">
                <a
                  (click)="showModalPrecedent(element)"
                  *ngIf="element.id != 0"
                >
                  <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Ação</th>
              <td mat-cell *matCellDef="let element">
                <textarea
                  [(ngModel)]="element.precedent"
                  class="form-control"
                  data-cy="precedent"
                  rows="3"
                  maxlength="250"
                  name="precedent-{{ element.id }}"
                  [disabled]="element.id != 0"
                ></textarea>
              </td>
            </ng-container>

            <ng-container matColumnDef="responsable">
              <th
                mat-header-cell
                matTooltip="Escolha a área ou usuário externo para determinar o responsável pelo parecer/ação."
                *matHeaderCellDef
              >
                Responsável
              </th>
              <td mat-cell *matCellDef="let element">
                <select
                  required
                  class="form-control"
                  id="reviewerGroupId"
                  [value]="element.reviewerGroupId"
                  [(ngModel)]="element.reviewerGroupId"
                  name="reviewerGroupId-{{ element.id }}"
                  [disabled]="element.id != 0"
                >
                  <option
                    *ngFor="let item of reviewersDecisionToPrecedentList"
                    [value]="item.groupId"
                    [disabled]="element.id != 0"
                  >
                    {{ item.groupName }}
                  </option>
                </select>
              </td>
            </ng-container>

            <ng-container matColumnDef="responsableEmailNotification">
              <th
                mat-header-cell
                matTooltip="Este email receberá uma mensagem contendo o link para esta boleta. Será necessário que este usuário tenha acesso à Boletagem e utilize seu próprio login e senha."
                *matHeaderCellDef
              >
                Responsável notificado por email
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  [disabled]="element.id != 0"
                  type="email"
                  [(ngModel)]="element.email"
                  class="form-control"
                  data-cy="email"
                  name="email-{{ element.id }}"
                />
              </td>
            </ng-container>

            <ng-container matColumnDef="documents">
              <th mat-header-cell *matHeaderCellDef>Documentos</th>
              <td mat-cell *matCellDef="let element" style="width: 250px">
                <input
                  class="btn-margin"
                  #thisInput
                  type="file"
                  multiple
                  name="file-{{ element.id }}"
                  data-cy="uploadFile"
                  (change)="openPrecedentFile($event)"
                />
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                matTooltip="Você é o líder do status deste precedente e ele não impede de você modificar o status da boleta, lhe ajuda a controlar as ações necessárias, pendencias, responsaveis e a manter a rastreabilidade dos documentos para sua decisão de parecer."
                *matHeaderCellDef
              >
                Status
              </th>
              <td mat-cell *matCellDef="let element">
                <select
                  required
                  class="form-control"
                  id="precedentStatus"
                  [value]="element.precedentStatus"
                  [(ngModel)]="element.precedentStatus"
                  name="precedentStatus-{{ element.id }}"
                  [disabled]="element.id != 0 && !isCreatorPrecedent(element)"
                >
                  <option
                    *ngFor="let item of precedentStatusList"
                    [value]="item.id"
                  >
                    {{ item.status }}
                  </option>
                </select>
              </td>
            </ng-container>

            <ng-container matColumnDef="addRow">
              <th class="faIconColumn" mat-header-cell *matHeaderCellDef>
                <a (click)="addRow()">
                  <fa-icon
                    class="faPlusIcon"
                    [icon]="faPlus"
                    title="Adicionar Nova Linha"
                  ></fa-icon>
                </a>
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="button"
                  value="Salvar"
                  class="btn-margin btn btn-primary"
                  appDebounceClick
                  (debounceClick)="createPrecedent(element)"
                  [debounceTime]="200"
                  data-cy="submit"
                />
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="ColumnsPrecedent"></tr>
            <tr mat-row *matRowDef="let row; columns: ColumnsPrecedent"></tr>
          </table>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div
    *ngIf="
      model.statusId == WorkFlowStatusEnum.StructuredReadyToOperate ||
      model.statusId == WorkFlowStatusEnum.StructuredFinalReviewerDecision ||
      model.statusId == WorkFlowStatusEnum.StructuredCompleted
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Ativos Aprovados </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="content">
        <div class="table">
          <table
            mat-table
            [dataSource]="approvedAssetsDataSource"
            class="mat-elevation-z8 col-12"
          >
            <ng-container matColumnDef="comments">
              <th
                mat-header-cell
                matTooltip="Deixe registrado o racional da decisão final, para servir de análise futura conforme as operações irão chegar"
                *matHeaderCellDef
              >
                Comentário para Controle das Operações
              </th>
              <td mat-cell *matCellDef="let element">
                <textarea
                  [(ngModel)]="element.comments"
                  class="form-control"
                  data-cy="as-comments"
                  rows="3"
                  maxlength="250"
                  name="as-comments-{{ element.id }}"
                  [disabled]="
                    disableApproveAssets() || !disableApproveAssetsGroup()
                  "
                  required
                ></textarea>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="assetName">
              <th
                mat-header-cell
                matTooltip="Escreva o nome do Ativo"
                *matHeaderCellDef
              >
                Nome do Ativo
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="text"
                  [(ngModel)]="element.assetName"
                  class="form-control"
                  data-cy="as-assetName"
                  name="as-assetName-{{ element.id }}"
                  [disabled]="
                    disableApproveAssets() || !disableApproveAssetsGroup()
                  "
                  required
                />
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="amount">
              <th
                mat-header-cell
                matTooltip="Escreva a quantidade maxima deste ativo no global"
                *matHeaderCellDef
              >
                Quantidade Aprovada
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="text"
                  [(ngModel)]="element.amount"
                  class="form-control"
                  data-cy="as-amount"
                  name="as-amount-{{ element.id }}"
                  [disabled]="
                    disableApproveAssets() || !disableApproveAssetsGroup()
                  "
                  required
                  (paste)="onNewAssetQuantityPaste($event, element)"
                  (input)="onNewAssetQuantityInput($event, element)"
                />
              </td>
              <td mat-footer-cell *matFooterCellDef>
                Total: {{ getTransformedTotalAmount() }}
              </td>
            </ng-container>

            <ng-container matColumnDef="approvedValue">
              <th
                mat-header-cell
                matTooltip="Escreva o financeiro máximo no global deste ativo"
                *matHeaderCellDef
              >
                Financeiro Aprovado
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="text"
                  [(ngModel)]="element.approvedValue"
                  class="form-control"
                  data-cy="as-approvedValue"
                  name="as-approvedValue-{{ element.id }}"
                  [disabled]="
                    disableApproveAssets() || !disableApproveAssetsGroup()
                  "
                  required
                  currencyMask
                />
              </td>
              <td mat-footer-cell *matFooterCellDef>
                Total:
                {{
                  totalApprovedAssetsValue
                    | currency : "R$" : "symbol" : "1.2-6"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="limitDate">
              <th
                mat-header-cell
                matTooltip="Escreva a data limite global deste ativo (conceito vencimento dado os riscos envolvidos)"
                *matHeaderCellDef
              >
                Data Limite para Operar/Liquidar
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  type="text"
                  [(ngModel)]="element.limitDate"
                  class="form-control"
                  data-cy="as-limitDate"
                  name="as-limitDate-{{ element.id }}"
                  [textMask]="{ mask: validator.dateMask, guide: false }"
                  [disabled]="
                    disableApproveAssets() || !disableApproveAssetsGroup()
                  "
                  required
                />
              </td>
              <td mat-footer-cell *matFooterCellDef>
                Data Máxima: {{ biggestLimitDate | date: "dd/MM/yyyy" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="addRow">
              <th class="faIconColumn" mat-header-cell *matHeaderCellDef>
                <a
                  *ngIf="!disableApproveAssets() && disableApproveAssetsGroup()"
                  (click)="addApprovedAssetRow()"
                >
                  <fa-icon
                    class="faPlusIcon"
                    [icon]="faPlus"
                    title="Adicionar Nova Linha"
                  ></fa-icon>
                </a>
              </th>
              <td mat-cell *matCellDef="let element">
                <input
                  *ngIf="!disableApproveAssets() && disableApproveAssetsGroup()"
                  type="button"
                  value="Salvar"
                  class="btn-margin btn btn-primary"
                  appDebounceClick
                  (debounceClick)="createApprovedAsset(element)"
                  [debounceTime]="200"
                  data-cy="as-submit"
                />
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="ColumnsApprovedAssets"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: ColumnsApprovedAssets"
            ></tr>
            <tr mat-footer-row *matFooterRowDef="ColumnsApprovedAssets"></tr>
          </table>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div
    *ngIf="
      (model.id != null &&
        model.id != 0 &&
        model.statusId == WorkFlowStatusEnum.StructuredReadyToOperate) ||
      model.statusId == WorkFlowStatusEnum.StructuredCompleted
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Ordens </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content">
        <app-ordem-operacao-estruturada-lista
          [mainTicketId]="model.id"
          [statusDescription]="model.statusDescription"
          [totalApprovedAssetsValue]="totalApprovedAssetsValue"
          [totalApprovedAssetsAmount]="totalApprovedAssetsAmount"
          [biggestLimitTimestamp]="biggestLimitTimestamp"
          [structuredOperationAssetId]="model.operationTypeFile.structuredOperationAssetId"
          [structuredOperationAssetSubtypeId]="model.operationTypeFile.structuredOperationAssetSubtypeId"
        >
        </app-ordem-operacao-estruturada-lista>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submitTicket()"
      [debounceTime]="200"
      data-cy="submit"
    />
    <input
      type="button"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
      data-cy="forward"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
      data-cy="cancel"
    />
  </div>

  <div
    class="actions"
    *ngIf="
      canChangeStatus() &&
      model.statusId != WorkFlowStatusEnum.StructuredInAnalysis
    "
  >
    <input
      *ngIf="model.statusId != WorkFlowStatusEnum.StructuredReadyToOperate"
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      data-cy="approve"
    />
    <input
      *ngIf="model.statusId == WorkFlowStatusEnum.StructuredReadyToOperate"
      type="button"
      value="Encerrar inserção de operações"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      data-cy="approve"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      data-cy="reject"
    />
    <!-- <input *ngIf="model.statusDescription == 'Em Análise'" type="button" value="Aprovar com Ressalva"
      class="btn btn-warning" appDebounceClick (debounceClick)="showModalReservation()" [debounceTime]="200"
      data-cy="reject" /> -->
  </div>

  <!-- <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      class="btn btn-primary"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
      data-cy="duplicate"
    />
  </div> -->
</form>

<br />

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
